import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	pipelineId: Yup.string().required('Pipeline is required.'),
	name: Yup.string().trim().required('Name is required.'),
	stageId: Yup.string().required('Stage is required.'),
	isActive: Yup.boolean(),
});

export default validationSchema;
